export class ConstantsUrl{
    static BASE = 'https://apiadm.legaltrip.com.br/questoeslegais-api-1';
    static BASE1 = 'http://localhost:8080/questoeslegais-api';
}